import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/schedule.png'


const _hoisted_1 = {
  class: "card border-0 rounded-3 mb-4",
  style: {"background-color":"#7c24cc"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"card-body p-4 py-5 p-xl-5 text-center\"><h2 class=\"text-white fs-24 fw-semibold mb-2\">Schedule Appointment</h2><p class=\"text-white fs-14 m-auto\" style=\"max-width:273px;\"> Quickly schedule an appointment for a patient with any available doctor </p><div class=\"py-4 mb-2\"><img src=\"" + _imports_0 + "\" alt=\"schedule\"></div><button class=\"btn btn-primary py-2 px-4 fs-16 fw-medium text-white\"> Book Appointment </button></div>", 1)
  ]))]))
}